import { DD, DT, FormField, GridCol, GridRow, isDefinedNumber, Select, toPercent, Typography } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { FormValues, FormPath } from '../agreement-conditions-card.component';

const PERCENTAGE_OPTIONS: number[] = Array.from(Array(11).keys(), (x) => x / 10);

interface VatInformationProps {
  isFetching: boolean;
  editing: boolean;
  vatInclusivePercentage?: number | null;
}

export const VatInformation = ({ isFetching, editing, vatInclusivePercentage }: VatInformationProps) => {
  const { t: tGlobal } = useTranslation('global');

  return (
    <div className="py-2" data-testid="vat-information">
      <Typography variant="none" className="mb-4 text-brand-primary font-medium uppercase text-xs">
        {tGlobal('agreement.vatInformation')}
      </Typography>

      <GridRow cols={3} spacing={2} className="items-center">
        <GridCol span={1}>
          <DT>{tGlobal('agreement.vatInclusivePercentage')}</DT>
        </GridCol>
        <GridCol span={2} loading={isFetching}>
          {!editing ? (
            <DD isEmpty={!isDefinedNumber(vatInclusivePercentage)}>{toPercent(vatInclusivePercentage)}</DD>
          ) : (
            <FormField<FormValues, FormPath>
              name="vatInclusivePercentage"
              render={({ field }) => (
                <Select {...field} size="medium">
                  <option value="" />
                  {PERCENTAGE_OPTIONS.map((percentage) => (
                    <option key={percentage} value={percentage}>
                      {percentage * 100}%
                    </option>
                  ))}
                </Select>
              )}
            />
          )}
        </GridCol>
      </GridRow>
    </div>
  );
};
